// src/services/studyService.js
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getStudiesPath } from "./firestorePaths";

// ✅ Fetch all studies
export const fetchStudies = async () => {
  const snapshot = await getDocs(collection(db, getStudiesPath()));
  return snapshot.docs.map((doc) => {
  const data = doc.data();

  return {
    ...data,
    id: doc.id, // ✅ force override LAST
  };
});
};

// ✅ Add a new study
export const createStudy = async (studyData) => {
  await addDoc(collection(db, getStudiesPath()), studyData);
};

// ✅ Update an existing study
export const updateStudy = async (id, updatedData) => {
  const studyDoc = doc(db, getStudiesPath(), id);
  await updateDoc(studyDoc, updatedData);
};

export const deleteStudy = async (id) => {
  const studyDoc = doc(db, getStudiesPath(), id);
  await deleteDoc(studyDoc);
};
